/** Only ordinary pages can be return destinations. Never retain credentials
 * or return somebody to a spent invitation / sign-in callback. */
export function scoreReturnPath(value: unknown, origin: string): string | null {
  if (typeof value !== "string") return null;
  try {
    const url = new URL(value, origin);
    if (url.origin !== origin || /^\/(?:login|invite|api)(?:\/|$)/.test(url.pathname)) return null;
    if (/[#&](?:k|tgWebAppData|tgWebAppStartParam)=/.test(url.hash)) return null;
    return url.pathname + url.search + url.hash;
  } catch {
    return null;
  }
}
